import { SampleDialog } from "@/components/landing/SampleDialog";
import { SampleEasyExercise } from "@/components/landing/SampleEasyExercise";
import { Button } from "@/components/ui/button";
import { RoutesConfig } from "@/shared/lib/model/routes";
import type { NextPageWithLayout } from "@/shared/lib/types/layoutTypes";
import { MainLayout } from "@/widgets/MainLayout";
import Link from "next/link";

const Home: NextPageWithLayout = () => {
	return (
		<div className="flex flex-col gap-2 bg-background pb-4">
			<section className="flex flex-col md:flex-row gap-2">
				<div className="rounded-3xl shrink-0 w-full md:w-1/2 bg-gradient-to-b h-40 md:h-auto from-[#4D80E6] to-[#E5E4E6]" />
				<div className="bg-background-grey flex flex-col gap-8 rounded-3xl w-full md:w-1/2 p-6 min-h-0">
					<div className="flex flex-col gap-8 shrink-0">
						<div className="flex flex-col gap-3">
							<h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">
								Master English with Neural Networks
							</h1>
							<p className="text-md max-w-md text-muted-foreground ">
								Transform your English learning journey with personalized AI
								tutoring, interactive practice sessions, and adaptive learning paths
								designed just for you.
							</p>
						</div>
						<Button size={"lg"} asChild className="max-w-md text-lg font-medium">
							<Link prefetch={false} href={RoutesConfig.signUp.path}>
								{" "}
								Try for free
							</Link>
						</Button>
					</div>
					<div className="flex-1 min-h-0">
						<SampleDialog />
					</div>
				</div>
			</section>
			<section className="flex flex-col-reverse md:flex-row gap-2">
				<div className="bg-background-grey flex flex-col gap-8 rounded-3xl w-full md:w-1/2 p-6 min-h-0">
					<div className="flex flex-col gap-3 shrink-0">
						<h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
							Interactive AI-Generated Exercises
						</h2>
						<p className="text-md max-w-md text-muted-foreground">
							Practice with dynamically generated exercises tailored to your skill
							level. Get instant feedback and learn from your mistakes.
						</p>
					</div>
					<div className="flex-1 min-h-0">
						<SampleEasyExercise />
					</div>
				</div>
				<div className="rounded-3xl w-full shrink-0 md:w-1/2 bg-gradient-to-b h-40 md:h-auto from-[#E6804D] to-[#E5E4E6]" />
			</section>
		</div>
	);
};

Home.getLayout = MainLayout;

export default Home;
